import { render, staticRenderFns } from "./Policy-orders.vue?vue&type=template&id=045c4b66&scoped=true"
import script from "./PolicyOrders.js?vue&type=script&lang=js&external"
export * from "./PolicyOrders.js?vue&type=script&lang=js&external"
import style0 from "./Policy-orders.vue?vue&type=style&index=0&id=045c4b66&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "045c4b66",
  null
  
)

export default component.exports